import React from 'react';
import { useAppStore } from '../../../store/useAppStore';
import type { PermissionValue } from '../types';
import { canUseProjectPermission } from '../project-permission';

interface PermissionGuardProps {
    permission: PermissionValue;
    children: React.ReactNode;
    fallback?: React.ReactNode;
    hideIfDenied?: boolean;
}

/**
 * PermissionGuard Component
 * Conditionally renders children based on user permissions
 * 
 * @example
 * <PermissionGuard permission={Permission.EDIT_PROPS}>
 *   <Button>Edit Props</Button>
 * </PermissionGuard>
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
    permission,
    children,
    fallback = null,
    hideIfDenied = false
}) => {
    const cloudEnabled = useAppStore((state) => state.cloud.enabled);
    const cloudMember = useAppStore((state) => state.cloud.member);
    const user = useAppStore((state) => state.auth.user);
    const roles = useAppStore((state) => state.admin.roles);

    const hasPermission = canUseProjectPermission({
        cloudEnabled,
        member: cloudMember,
        permission,
        roles,
        user,
    });

    if (!hasPermission) {
        return hideIfDenied ? null : fallback;
    }

    return <>{children}</>;
};










